import { chatRpc, FILE_BUCKET, validateChatFile } from './m9AppChat';
export async function uploadDocument(client, accountId, file, tripId = null) {
    validateChatFile(file);
    const reserved = await chatRpc(client, 'm9_file_reserve', { p_account: accountId, p_fields: {
        name: file.name.slice(0, 180), mime: file.type, size: file.size, kind: 'document', tripId,
    } });
    const { error } = await client.storage.from(FILE_BUCKET).upload(reserved.path, file, { contentType: file.type, upsert: false });
    if (error) throw error;
    return chatRpc(client, 'm9_file_complete', { p_file: reserved.id });
}
export async function documentDownload(client, fileId, { download = true } = {}) {
    const file = await chatRpc(client, 'm9_file_get', { p_file: fileId });
    const { data, error } = await client.storage.from(FILE_BUCKET).createSignedUrl(file.path, 300, download ? { download: file.name } : {});
    if (error || !data?.signedUrl) throw error || new Error('File unavailable');
    return data.signedUrl;
}
export function documentError(error, action = 'open your documents') {
    if (/check your bookings/i.test(error?.message || '')) return 'Please check your bookings before trying again. Your request may already be saved.';
    if (error?.message === 'Your booking options are not available.') return error.message;
    if (/^Please call us\.?$/i.test(error?.message || '')) return error.message;
    if (error?.message === 'Choose a JPG, PNG, GIF, or PDF up to 10 MB.') return error.message;
    if (typeof navigator !== 'undefined' && navigator.onLine === false) return 'You’re offline. Connect to the internet, then try again.';
    if (error?.code === '42501' || /access denied|not available for this account/i.test(error?.message || '')) return 'This file isn’t available for your account right now. Please contact your account team.';
    return `We couldn’t ${action}. Please try again. If it keeps happening, contact your account team.`;
}
